/**
 * @package DMV Offices
 * @version 1.0.0
 */
/* global ga */

$(document).ready(function() {
  // allow only numbers in "Search by ZIP" form
  $('#search-by-zip input[type=text]').on('keyup', function() {
    if (/\D/g.test(this.value)) {
      this.value = this.value.replace(/\D/g, '');
    }
  });

  // submit the form with ajax
  $('#search-by-zip').submit(function(event) {
    event.preventDefault();
    let $message = $('#search-by-zip .message');
    let $submit = $('#search-by-zip button');
    let $form_data = $('#search-by-zip').serialize();
    $submit.prop({ disabled: true });

    $.ajax({
      type: 'post',
      dataType: 'json',
      url: '/wp-admin/admin-ajax.php',
      data: $form_data,
    })

    .done(function(response) {
      $submit.prop({ disabled: false });
      if (response.error) {
        $message.html(`<p class="alert alert-danger mt-3 mb-0">${response.message}</p>`).slideDown();
        return;
      }
      $message.html(`<p class="alert alert-success mt-3 mb-0">${response.message}</p>`).slideDown();
      window.location = response.location;
    });
  });

  // hide all offices past the first three
  /*
  let $overflow = $('.offices-list > div:gt(2)');
  let $more = $('.offices-handler .more a');
  if ($overflow.length) {
    $overflow.hide();
    $more.removeClass('d-none').on('click', function(event) {
      event.preventDefault();
      $overflow.show();
      $more.remove();
    });
  }
  */

  // track clicks on Services icons with Google Analytics
  $('body.single-office .available-services a').on('click', function() {
    ga('gtm1.send', 'event', 'link', 'click',
      $(this).attr('href'), {
      'eventCategory': 'DMV Office service icon',
      'eventAction': 'Icon click',
      'eventLabel': $(this).text(),
      'campaignName': 'Office Services',
      'campaignKeyword': 'DMV Offices',
    });
  });
});



// WEBPACK FOOTER //
// ./scripts/plugins/dmv-office/index.js